import React, { Component } from 'react';
import _ from 'lodash';

import { FeaturedPrograms } from './FeaturedPrograms.js';
import { ProgramDetails } from './ProgramDetails.js'
import { QASection } from './QASection.js'
import { ProgramTitle } from './ProgramTitle.js'
import { OrganizerDetails } from './OrganizerDetails.js';

export class ProgramDetailPage extends Component {
    constructor(props) {
        super(props);

        let programID = this.props.match.params.programID;
        let programObject = _.find(this.props.firebaseData.programs, { id: programID }); //find program in firebaseData

        this.state = {
            program: programObject
        };
    }

    // Make the window move to top on the first access
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    // Make the window move to top on the following access
    componentDidUpdate(prevProps) {
        if (this.props.match.params.programID !== prevProps.match.params.programID) {
            window.scrollTo(0, 0);
            let programObject = _.find(this.props.firebaseData.programs, { id: this.props.match.params.programID });
            this.setState({ program: programObject });
        }
    }

    render() {

        // display information about the organizer who created the program
        let organizerDetails = _.find(this.props.firebaseData.organizers, { uid: this.state.program.organizer });
        return (

            // program detail page layout
            <div id="program-details">
                <section>
                    <ProgramPhoto
                        program={this.state.program}
                        fav={this.props.fav} />
                    <ProgramTitle
                        program={this.state.program}
                        logInMember={this.props.logInMember}
                        fav={this.props.fav}
                        saveFav={this.props.saveFav} />
                    <ProgramInfo
                        program={this.state.program} />
                    <QASection
                        program={this.state.program}
                        logInMember={this.props.logInMember}
                        submit={this.props.submit}
                        user={this.props.user} />
                    <OrganizationInfo organizer={organizerDetails} />
                </section>
                <section id="program-list">
                    <FeaturedPrograms
                        data={this.props.firebaseData.programs}
                        title="Featured Programs"
                        viewAll="false"
                        logInMember={this.props.logInMember}
                        logInOrg={this.props.logInOrg}
                        fav={this.props.fav}
                        saveFav={this.props.saveFav}
                        currentProgram={this.state.program}
                        addProgram={this.props.addProgram}
                        user={this.props.user} />
                </section>
            </div>
        );
    }
}

export class ProgramPhoto extends Component {
    render() {
        let program = this.props.program;
        return (
            <div id="program-photo">
                <img className="img-fluid" src={program.src} alt={program.altText} />
            </div>
        );
    }
}

// program's detailed information
export class ProgramInfo extends Component {
    render() {
        let program = this.props.program;
        return (
            <section id="program-info"><ProgramDetails program={program} /></section>
        );
    }
}

// organizer's information
export class OrganizationInfo extends Component {
    render() {
        return (
            <section id="organization-info" className="bg-white">
                <OrganizerDetails organizer={this.props.organizer} />
            </section>
        );
    }
}
